import { get, post, remove } from '@va/http-client';
import { storageItems } from '@va/standalone/shared/constants';
import { LocalStorage } from '@va/util/helpers';

export const confirmUpdateEmail = (data) => {
  const url = `/users/confirm-update-email`;

  return post(url, {}, data);
};

export const resetEmail = (data) => {
  const url = `/users/reset-email`;

  return post(url, {}, data);
};

export const deleteAccount = (data) => {
  const id = LocalStorage.getItem(storageItems.userId);
  const url = `/users/${id}`;

  return remove(url, data);
};

export const acceptContributorRole = (data, id) => {
  const url = `/contributors/requests/${id}/accept`;

  return post(url, {}, data);
};

export const rejectContributorRole = (data, id) => {
  const url = `/contributors/requests/${id}/reject`;

  return post(url, {}, data);
};

export const acceptContributorRoleWithToken = (data) => {
  const url = `/contributors/requests/accept`;

  return post(url, {}, data);
};

export const resendRegisterConfirmation = (data) => {
  const url = `/users/confirm-resend`;

  return post(url, {}, data);
};

export const createWebsiteForMigration = (data, userId) => {
  const url = `/migrations/users/${userId}/websites`;

  return post(url, {}, data);
};

export const createNewUserForMigration = (data) => {
  const url = `/migrations/users`;

  return post(url, {}, data);
};

export const getVouchersInfo = (userId) => {
  const id = userId || LocalStorage.getItem(storageItems.userId);
  const url = `/sumo/users/${id}/vouchers/info`;
  return get(url, {});
};
